import React from 'react'
import { SessionData } from '@/app/adapters/types'
import { ListingsProvider } from './ListingsContext'
import { OffMarketListingsProvider } from './OffMarketListingsContext'

/**
 * Combined provider that wraps both Listings and OffMarketListings contexts
 * for convenience when both are needed in the same component tree.
 */
export const CombinedListingsProvider: React.FC<{
	children: React.ReactNode
	sessionData: SessionData
}> = ({ children, sessionData }) => {
	return (
		<ListingsProvider sessionData={sessionData}>
			<OffMarketListingsProvider sessionData={sessionData}>{children}</OffMarketListingsProvider>
		</ListingsProvider>
	)
}

// Re-export hooks for convenience
export { useListings } from './ListingsContext'
export { useOffMarketListings } from './OffMarketListingsContext'

// Re-export individual providers
export { ListingsProvider } from './ListingsContext'
export { OffMarketListingsProvider } from './OffMarketListingsContext'

// Re-export types
export type { TableState, TableActions } from '../../../app/utilities/tableUtils'
